module.exports = __webpack_public_path__ + "img/photo-15.1e56be8c.jpg";